import React from 'react';
import {
  Box,
  Container,
  Stack,
  Text,
  IconButton,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footerx = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const hasUser = typeof window !== 'undefined' && !!localStorage.getItem('user');
  const hideOnMobileAppShell =
    hasUser &&
    location.pathname !== '/' &&
    location.pathname !== '/Account-disabled' &&
    location.pathname !== '/terms';

  const bg = useColorModeValue('white', 'surface.900');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textMuted = useColorModeValue('gray.600', 'whiteAlpha.600');
  const iconColor = useColorModeValue('gray.600', 'whiteAlpha.700');
  const iconHoverBg = useColorModeValue('brand.50', 'whiteAlpha.100');

  const footerDisplay = { base: hideOnMobileAppShell ? 'none' : 'block', lg: 'block' };

  return (
    <Box mt="auto" display={footerDisplay}>
      <Box bg={bg} color={textMuted} borderTop="1px solid" borderColor={borderColor} py={6}>
        <Container maxW="6xl">
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4} justify="space-between" align="center">
            <Text fontSize="sm" color={textMuted} textAlign={{ base: 'center', md: 'left' }}>
              {t('footer.rights')}
              <Text as="span" mx={2} color={textMuted} opacity={0.5}>
                ·
              </Text>
              <Link
                to="/terms"
                style={{
                  color: 'inherit',
                  fontSize: 'inherit',
                  fontWeight: 400,
                  textDecoration: 'none',
                }}
              >
                <Text
                  as="span"
                  fontSize="inherit"
                  fontWeight={400}
                  color={textMuted}
                  _hover={{ textDecoration: 'underline' }}
                >
                  {t('footer.terms')}
                </Text>
              </Link>
            </Text>
            <HStack spacing={2}>
              <Link to={process.env.REACT_APP_X_Link} target="_blank" rel="noopener noreferrer">
                <IconButton
                  aria-label={t('footer.twitter')}
                  icon={<FaTwitter />}
                  size="sm"
                  variant="ghost"
                  color={iconColor}
                  _hover={{ bg: iconHoverBg, color: 'brand.500' }}
                  borderRadius="full"
                />
              </Link>
              <Link to={process.env.REACT_APP_INSTAGRAM_Link} target="_blank" rel="noopener noreferrer">
                <IconButton
                  aria-label={t('footer.instagram')}
                  icon={<FaInstagram />}
                  size="sm"
                  variant="ghost"
                  color={iconColor}
                  _hover={{ bg: iconHoverBg, color: 'brand.500' }}
                  borderRadius="full"
                />
              </Link>
              <Link to={process.env.REACT_APP_LINKEDIN_Link} target="_blank" rel="noopener noreferrer">
                <IconButton
                  aria-label={t('footer.linkedin')}
                  icon={<FaLinkedin />}
                  size="sm"
                  variant="ghost"
                  color={iconColor}
                  _hover={{ bg: iconHoverBg, color: 'brand.500' }}
                  borderRadius="full"
                />
              </Link>
            </HStack>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default Footerx;
